import { render, staticRenderFns } from "./group-profile.vue?vue&type=template&id=ddc7eb88&"
import script from "./group-profile.vue?vue&type=script&lang=js&"
export * from "./group-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports